import { jsx as t } from "react/jsx-runtime";
import o from "react-markdown";
import l from "remark-gfm";
import { c as a } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const m = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  h1: (e) => /* @__PURE__ */ t("h1", { className: "text-3xl font-bold tracking-tight text-foreground mb-4", ...e }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  h2: (e) => /* @__PURE__ */ t("h2", { className: "text-2xl font-semibold tracking-tight text-foreground mt-8 mb-4", ...e }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  h3: (e) => /* @__PURE__ */ t("h3", { className: "text-xl font-semibold tracking-tight text-foreground mt-6 mb-3", ...e }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  p: (e) => /* @__PURE__ */ t("p", { className: "leading-7 text-foreground [&:not(:first-child)]:mt-6", ...e }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  a: (e) => /* @__PURE__ */ t("a", { className: "font-medium text-primary hover:underline underline-offset-4", target: "_blank", rel: "noopener noreferrer", ...e }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ul: (e) => /* @__PURE__ */ t("ul", { className: "my-6 ml-6 list-disc [&>li]:mt-2 text-foreground", ...e }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ol: (e) => /* @__PURE__ */ t("ol", { className: "my-6 ml-6 list-decimal [&>li]:mt-2 text-foreground", ...e }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  blockquote: (e) => /* @__PURE__ */ t("blockquote", { className: "mt-6 border-l-2 border-border pl-6 italic text-muted-foreground", ...e }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  table: (e) => /* @__PURE__ */ t("div", { className: "my-6 w-full overflow-y-auto", children: /* @__PURE__ */ t("table", { className: "w-full text-sm", ...e }) }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  th: (e) => /* @__PURE__ */ t("th", { className: "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted px-4 py-2 text-left font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0", ...e }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  td: (e) => /* @__PURE__ */ t("td", { className: "p-4 align-middle [&:has([role=checkbox])]:pr-0 border-b", ...e })
}, u = ({
  content: e,
  className: r
}) => /* @__PURE__ */ t("div", { className: a("prose prose-slate dark:prose-invert max-w-none", r), children: /* @__PURE__ */ t(
  o,
  {
    remarkPlugins: [l],
    components: m,
    children: e
  }
) });
export {
  u as M
};
